module.exports = __webpack_public_path__ + "images/a221eb28f77f0ea293abc954be0ebed1216993c0a264dda00c6116ef50547eea.svg";